import Image from "next/image";

export default function WhyMeasureProgesterone() {
  return (
    <div className="bg-[#ffeecc] py-12 px-5 w-full">
      <div>
        <h2 className="title-32 text-[#232221] mb-4">
          Why Measure <br /> Progesterone?
        </h2>

        <p className="title-16 text-[#122d35] mb-4">
          Anovulation (having a menstrual cycle with no egg) is actually a
          common occurrence, affecting 1 in 10 women*.
        </p>

        <p className="title-16 text-[#122d35] mb-4">
          If ovulation occurs, the levels of Progesterone and its urine
          metabolite PdG rise after a few days and stay elevated. Sustained,
          elevated PdG levels after peak fertility indicate a successful
          ovulation.
        </p>

        <p className="title-16 text-black/50 mt-2.5">
          * Source: National Institutes of Health
        </p>

        <div className="w-full h-px bg-[#d1b08a] my-8" />
      </div>

      <div className="body-17 text-black mt-3.5 mb-6">
        &ldquo;Inito is all that you need to give you the best chance of
        conception.&rdquo;
      </div>
      <div className="flex items-center gap-4 mt-2.5">
        <Image
          src="https://cdn.inito.com/rebrand_quiz/v1/result/doctor.jpeg"
          alt="Dr. Rachel Wagner"
          width={50}
          height={50}
          className="w-[50px] h-[50px] rounded-full object-cover"
        />

        <div className="flex flex-col title-16 text-black">
          <span>Dr. Rachel Wagner</span>
          <span className="title-14">MD</span>
        </div>
      </div>
    </div>
  );
}
